import { createAction } from 'redux-actions'
import fetch from 'lib/fetch'

export const REQUEST_LOCKOUTS = 'REQUEST_LOCKOUTS'
export const REQUEST_LOCKOUTS_ERROR = 'REQUEST_LOCKOUTS_ERROR'
export const RECEIVE_LOCKOUTS = 'RECEIVE_LOCKOUTS'
export const REQUEST_LOCKOUT_BY_WORKSPACE_SLUG = 'REQUEST_LOCKOUT_BY_WORKSPACE_SLUG'
export const REQUEST_LOCKOUT_BY_WORKSPACE_SLUG_ERROR = 'REQUEST_LOCKOUT_BY_WORKSPACE_SLUG_ERROR'
export const RECEIVE_LOCKOUT_BY_WORKSPACE_SLUG = 'RECEIVE_LOCKOUT_BY_WORKSPACE_SLUG'
export const CHANGE_LOCKOUT_STEP = 'CHANGE_LOCKOUT_STEP'

export const changeLockoutStep = createAction(CHANGE_LOCKOUT_STEP)

export function fetchLockouts () {
  return {
    types: {
      request: REQUEST_LOCKOUTS,
      failure: REQUEST_LOCKOUTS_ERROR,
      receive: RECEIVE_LOCKOUTS
    },
    callAPI: () => fetch('/api/lockouts').then(res => {
      if (!res.ok) {
        const err = new Error('Unable to fetch lockouts')
        err.status = res.status
        throw err
      }
      return res.json()
    })
  }
}

export function fetchLockoutByWorkspaceSlug (slug) {
  return {
    payload: {
      slug
    },
    types: {
      request: REQUEST_LOCKOUT_BY_WORKSPACE_SLUG,
      failure: REQUEST_LOCKOUT_BY_WORKSPACE_SLUG_ERROR,
      receive: RECEIVE_LOCKOUT_BY_WORKSPACE_SLUG
    },
    callAPI: () => fetch(`/api/workspaces/${slug}/lockout`).then(res => {
      if (!res.ok) {
        const err = new Error('Unable to fetch lockouts')
        err.status = res.status
        throw err
      }

      if (res.status === 204) {
        return null
      }

      return res.json()
    })
  }
}



// WEBPACK FOOTER //
// ./actions/lockouts.js